import "./SeriesAccess.css";

function SeriesAccess() {
  return (
    <main id="top" className="series-main">
      <div className="series-access">
        <div className="series-access-card">
          <div className="series-access-label">Free</div>

          <div className="series-access-text">
            EPU Index.PL, January 2000 to June 2026
          </div>
        </div>
        <a href="./Data.dc.html" className="series-access-button">
          See the data
          <span className="series-access-arrow">›</span>
        </a>
      </div>
    </main>
  );
}

export default SeriesAccess;